import { UserService } from '@profile/infra';
import { inject } from '@angular/core';
import { map, Observable, switchMap, take } from 'rxjs';
import { USER_DATA_TOKEN, UserDataProvider, UserModel } from '@core';
import { AppTrophyType, GetTrophiesPerUserResponse, UserTrophyDto } from '@core-http';

export class GetMyTrophyTypesQueryHandler {
  private readonly userService: UserService = inject(UserService);
  private readonly userDataProvider: UserDataProvider = inject(USER_DATA_TOKEN);

  getEarnedTypes(): Observable<AppTrophyType[]> {
    return this.userDataProvider.userData$.pipe(
      take(1),
      switchMap((user: UserModel) => this.userService.getUserTrophies({ userId: user.userId })),
      map((response: GetTrophiesPerUserResponse) => response.trophies.map((trophy: UserTrophyDto) => trophy.trophyType))
    );
  }
}
